<div class="chartLineWrapper" [ngClass]="{'fullWidth': isFullWidth, 'hasChartLabel': barChartData.chartLabel}">
    <span *ngIf="barChartData.chartLabel" class="chartLabel">{{barChartData.chartLabel}}</span>
    <div class="chartContainer" id={{barChartData.chartId}}></div>
</div>
